import { api, errorDetail } from "@/lib/api";

// MiLu opens the page behind a headline and tells the whole story, in the reader's language.
export const wholeStory = (story, lang = "") => async () => {
  try {
    const { data } = await api.get("/news/story/read", {
      params: {
        url: story.url,
        story_id: story.story_id || "",
        title: story.title || "",
        source: story.source || "",
        topic: story.topic || "",
        lang,
      },
      timeout: 90000,
    });
    return data.text;
  } catch (e) {
    throw new Error(errorDetail(e)
      || "MiLu could not open that story — tap the headline to read it on their site");
  }
};

// Two headlines that only differ by accents, case or punctuation are the same headline.
const bare = (text) =>
  (text || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase().replace(/[^a-z0-9]+/g, "");

export const sameHeadline = (a, b) => {
  const one = bare(a);
  const two = bare(b);
  if (!one || !two) return true;
  if (one === two || one.includes(two) || two.includes(one)) return true;
  // near enough: the same words in the same order, give or take a small word
  const words = (text) => new Set(bare(text).match(/.{1,4}/g) || []);
  const mine = words(a);
  const theirs = words(b);
  const shared = [...mine].filter((w) => theirs.has(w)).length;
  return shared / Math.max(mine.size, theirs.size) > 0.92;
};

// One bulletin: each story told, then a line about what is coming up next.
export const bulletin = (stories, lang = "", lines = null) =>
  stories.map((story, i) => {
    const next = stories[i + 1];
    const read = wholeStory(story, lang);
    return {
      key: `${story.story_id}-read`,
      label: story.title,
      getText: async () => {
        const told = await read();
        if (!lines) return told;
        const tail = next
          ? `${lines.next} ${next.title}, ${lines.from} ${next.source || ""}.`.replace(/\s+\./, ".")
          : lines.end;
        return `${told}\n\n${tail}`;
      },
    };
  });
